import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {getHistory, getAccessPlusHistory} from './store/action';
import GridList from '../Common/GridList';
import {Grid, Typography, CircularProgress} from '@material-ui/core';
import HistoryItemContent from './ItemContent';
import {translate} from 'react-admin';
import {compose} from 'recompose';

const HistoryItem = ({item}) => {
  return (
    <Grid container wrap="nowrap">
      <Grid item xs={2}>
        <Typography style={{fontWeight: 600}}>
          {new Date(
            (item.dateEvent.date || item.dateEvent).replace(' ', 'T'),
          ).toLocaleDateString()}
        </Typography>
      </Grid>
      <Grid item xs>
        <Typography style={{color: '#606060', fontWeight: 500}}>
          <HistoryItemContent item={item} />
        </Typography>
      </Grid>
    </Grid>
  );
};

class PartialAccessPlusHistory extends Component {
  componentDidMount() {
    const {id, getHistory, getAccessPlusHistory} = this.props;

    if (!id) {
      getAccessPlusHistory();
      return;
    }

    getHistory({type: id.split('/')[1], id: id.split('/')[2]});
  }

  componentDidUpdate = prevProps => {
    const {id, getHistory, refresh} = this.props;

    if (!id || (id === prevProps.id && !refresh)) {
      return;
    }

    getHistory({type: id.split('/')[1], id: id.split('/')[2]});
  };

  render() {
    const {title, historyAccessPlus, historyAccessPlusLoaded} = this.props;

    return !historyAccessPlusLoaded ? (
      <CircularProgress />
    ) : (
      <GridList
        data={historyAccessPlus}
        title={title && 'custom.commons.history'}
        noDataDesc="custom.commons.noHistory">
        <HistoryItem />
      </GridList>
    );
  }
}

PartialAccessPlusHistory.propTypes = {
  id: PropTypes.string,
  title: PropTypes.bool,
  historyAccessPlus: PropTypes.array.isRequired,
  historyAccessPlusLoaded: PropTypes.bool.isRequired,
};

const mapStatetoProps = ({historyReducer}) => ({
  historyAccessPlus: historyReducer.historyAccessPlus,
  historyAccessPlusLoaded: historyReducer.historyAccessPlusLoaded,
  refresh: historyReducer.refresh,
});

export default compose(
  translate,
  connect(mapStatetoProps, {
    getHistory,
    getAccessPlusHistory,
  }),
)(PartialAccessPlusHistory);
